import * as React from 'react';
import { cn } from '@/lib/utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  selectAllOnFocus?: boolean;
  ref?: React.Ref<HTMLInputElement>;
}

function Input({
  className,
  type,
  selectAllOnFocus = true,
  onFocus,
  ref,
  ...props
}: InputProps) {
  const hasFocusedRef = React.useRef(false);

  const handleFocus = React.useCallback(
    (e: React.FocusEvent<HTMLInputElement>) => {
      onFocus?.(e);

      if (selectAllOnFocus && !hasFocusedRef.current && e.target.value) {
        e.target.select();
        hasFocusedRef.current = true;
      }
    },
    [onFocus, selectAllOnFocus]
  );

  return (
    <input
      type={type}
      className={cn(
        'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      onFocus={handleFocus}
      {...props}
    />
  );
}
Input.displayName = 'Input';

export { Input };
